// BookOverlay.js
import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import './BookOverlay.scss';

// Mock imports for SVGs
import TopLeftSVG from '../../../images/BookOverlay/bookTopLeft.svg';
import TopRightSVG from '../../../images/BookOverlay/bookTopRight.svg';
import CloseButtonSVG from '../../../images/icons/closeButton.svg';
import Portal from '../Portal';

const BookOverlay = ({ leftPageContent, rightPageContent, onClose }) => {

  return (
    <Portal>
        <div className="book-overlay">
          <div className="book-column left">
            <img src={TopLeftSVG} alt="Top Left Page Curve" className="page-curve"/>
            <div className="page-content">{leftPageContent}</div>
          </div>
          <div className="book-column right">
            <button className="close-button" onClick={onClose}>
              <img src={CloseButtonSVG} alt="Close" />
            </button>
            <img src={TopRightSVG} alt="Top Right Page Curve" className="page-curve"/>
            <div className="page-content">{rightPageContent}</div>
          </div>
        </div>
    </Portal>
  );
};

BookOverlay.propTypes = {
  leftPageContent: PropTypes.node.isRequired,
  rightPageContent: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default BookOverlay;
